import { render, staticRenderFns } from "./LinkWooVariantModal.vue?vue&type=template&id=2f089a2a"
import script from "./LinkWooVariantModal.vue?vue&type=script&lang=js"
export * from "./LinkWooVariantModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports